import { buildApiEndpoint } from "../../../utils/api.utils";
import axiosInstance from '../../../axios.config';

export const fetchStepFilesContent = (fileNames, step) => {
    // Filter out any empty filenames BEFORE making API calls
    const validFileNames = fileNames.filter(name => name && name.trim().length > 0);
    
    if (validFileNames.length === 0) {
        return Promise.resolve([]);
    }
    
    const stepContentFilesPromises = validFileNames.map((fileName) => {
        const trimmedFileName = fileName.trim();
        
        const apiEndpoint = buildApiEndpoint("/CourseStep/filecontent", {
            CourseID: step.courseID,
            StepNo: step.stepNo,
            ContentType: step.contentType,
            FileName: trimmedFileName,
        });

        return axiosInstance.get(apiEndpoint, { responseType: "arraybuffer" })
            .catch(error => {
                console.error(`Failed to fetch ${trimmedFileName}:`, error.response?.status);
                return null;
            });
    });

    return Promise.all(stepContentFilesPromises);
};

export const fetchStepBgImgFileContent = (fileName, step) => {
    if (!fileName || !fileName.trim()) {
        return Promise.resolve(null);
    }
    
    const apiEndpoint = buildApiEndpoint("/CourseStep/filecontent", {
        CourseID: step.courseID,
        StepNo: step.stepNo,
        ContentType: "Image",
        FileName: fileName.trim(),
    });
    return axiosInstance.get(apiEndpoint, { responseType: "arraybuffer" })
        .catch(error => {
            console.error(`Failed to fetch background image ${fileName}:`, error.response?.status);
            return null;
        });
};

export const createBlobUrls = (responses, blobType) => {
    return Array.isArray(responses)
        ? responses
            .filter(response => response !== null) // Filter out failed requests
            .map((response) => {
                const blob = new Blob([response.data], { type: blobType });
                return URL.createObjectURL(blob);
            })
        : [];
};